<template>
  <div class="pageMain" :class="globalDataArray.siteInfo.greyOut == 1 ? 'bigEventGray' : ''">
    <!-- 第一板块 -->
    <div class="banner question_banner infoBanBox">
      <img :src="banners.image" alt="" class="infoBan">
      <div class=" w1200 infoBanCont">
        <div class="plcs">
          <div class="txt tion1">
            <p class="fnt_42">{{ competition.title }}</p>
          </div>
          <div class="tion2">
            <p class="fnt_18" v-for="(val, index) in competition.mark" :key="index">{{ val }}</p>
          </div>
          <div class="tion3">
            <ul class="box_tion3">
              <li v-if="competition.bonus!=''&&competition.bonus!=null">
                <p class="fnt_28">{{ competition.bonus }}</p>
                <span class="fnt_16"><img src="@/assets/images/stxq_img1.png" alt="">{{ globalDataArray.siteTemplateLanguage.competition_bonus }}</span>
              </li>
              <li>
                <p class="fnt_28" v-if="competition.teams!=null&&competition.teams!=''">{{ competition.teams > 999 ? '999+' : competition.teams }}</p>
                <p class="fnt_28" v-else>0</p>
                <span class="fnt_16"><img src="@/assets/images/stxq_img2.png" alt="">{{ globalDataArray.siteTemplateLanguage.competition_teams }}</span>
              </li>
              <li v-if="competition.categoryTitle!==''&&competition.categoryTitle!==null">
                <p class="fnt_28">{{ competition.categoryTitle }}</p>
                <span class="fnt_16"><img src="@/assets/images/stxq_img3.png" alt="">{{ globalDataArray.siteTemplateLanguage.category_select }}</span>
              </li>
              <li v-if="competition.signup!=''&&competition.signup!=null">
                <p class="fnt_28">
                  <!-- 已结束 -->
                  <template v-if="competition.signup=='04'">
                    {{ competition.signup_dictText }}
                  </template>
                  <template v-else>
                    <!-- 未开始跟进行中 -->
                    <template v-if="competition.signup=='01' || competition.signup=='02'">
                      {{ competition.signup_dictText }}
                    </template>

                    <!-- 报名中 -->
                    <template v-if="competition.signup=='03' && currentTime < competition.localEndtimeStr">
                      {{ competition.signup_dictText }}
                    </template>

                    <!-- 截止报名 -->
                    <template v-if="competition.signup=='03' && currentTime >= competition.localEndtimeStr">
                      {{ globalDataArray.siteTemplateLanguage.competition_signup_end }}
                    </template>
                  </template>
                </p>
                <span class="fnt_16"><img src="@/assets/images/stxq_img4.png" alt="">{{ globalDataArray.siteTemplateLanguage.competition_state }}</span>
              </li>
            </ul>
          </div>
          <div class="tion4" v-if="competition.signup!=''&&competition.signup!=null">
            <div class="tion4bm">
              <!-- 已结束 -->
              <template v-if="competition.signup=='04'">
                <span>{{ competition.signup_dictText }}</span>
              </template>
              <template v-else>
                <!-- 已经报名显示已报名 -->
                <template v-if="competition.isSignup == 1">
                  <span>{{ globalDataArray.siteTemplateLanguage.competition_signup_yes }}</span>
                </template>
                <template v-else>
                  <template v-if="currentTime < competition.localEndtimeStr">
                    <!-- 未开始跟进行中 -->
                    <template v-if="competition.signup=='01' || competition.signup=='02'">
                      <span>{{ competition.signup_dictText }}</span>
                    </template>

                    <!-- 报名中 -->
                    <template v-if="competition.signup=='03'">
                      <span @click="toSignFun(competition.templateId,competition.categoryId,competition.parentId,competition.teamsUsers)">{{ globalDataArray.siteTemplateLanguage.click_signup }}</span>
                    </template>
                  </template>

                  <!-- 截止报名 -->
                  <template v-else>
                    <span>{{ globalDataArray.siteTemplateLanguage.competition_signup_end }}</span>
                  </template>
                </template>
              </template>
            </div>
            <div class="tion4_txt fnt_16" v-if="competition.organizersLogo!='' || competition.organizers!=''">
              <div class="gjfTit">{{ globalDataArray.siteTemplateLanguage.competition_co_builder }}:</div>
              <div class="logo">
                <template v-if="competition.organizersLogo">
                  <span class="tion4span img" v-for="(val, index) in competition.organizersLogo" :key="index"><img :src="val" alt=""></span>
                </template>
                <template v-else>
                  <span class="tion4span txt" v-for="(val, index) in competition.organizers" :title="val" :key="index">{{ val }}</span>
                </template>
              </div>
            </div>
          </div>
          <div class="tion5">
            <p class="tion5_mintop fnt_16" v-if="competition.localStarttime!=''&&competition.localStarttime!=null">
              <img src="@/assets/images/stxq_ks.png" alt="">
              {{ globalDataArray.siteTemplateLanguage.competition_start_signup }}： <span>{{ competition.localStarttime }}<span class="utc8"> UTC+8</span></span>
            </p>
            <p class="tion5_mintop fnt_16" v-if="competition.localEndtime!=''&&competition.localEndtime!=null">
              <img src="@/assets/images/stxq_js.png" alt="">
              {{ globalDataArray.siteTemplateLanguage.competition_end_signup }}：<span>{{ competition.localEndtime }}<span class="utc8"> UTC+8</span></span>
            </p>
          </div>
        </div>
      </div>
    </div>

    <!-- 第二板块 -->
    <div class="question" v-if="competition.progress!=''&&competition.progress!=null">
      <div class="competition  w1200">
        <div class="process" v-for="(item,index) in competition.progress" :class="item.progressStatus == 0 ? 'on' : item.progressStatus == 1 ? 'active' : ''" :key="index">
          <p class="txtp">{{ item.title }}</p>
          <p class="time">{{ item.startDate }}</p>
        </div>
      </div>
    </div>

    <!-- 第三板块 -->
    <div class="contenta">
      <div class="w1200">
        <div class="content_mine" v-if="isClient && competition.info && competition.info.length">
          <div class="content_left">
            <div class="content_box">
              <h3 class="text-24 leading-30 mx-24 pb-18 pt-24 border-b-1 border-b-solid border-b-[rgba(0,0,0,0.1)]">
                {{ globalDataArray.siteTemplateLanguage.competition_box_left_top }}
              </h3>
              <ul>
                <template v-for="(item,index) in competition.info">
                  <li class="fnt_20" :class="index === event ? 'actire' : ''" :key="index">
                    <a href="javascript:;" @click="changeEvent(index)">{{ item.title }}</a>
                  </li>
                </template>
              </ul>
            </div>
          </div>
          <div class="content_right">
            <div class="content_st" v-if="info">
              <h3 class="fnt_20">{{ info.title }}</h3>
              <div class="txt ck-content markdown-content" v-html="parseMarkdown(info.content)"></div>
            </div>
          </div>
        </div>
        <div style="text-align:center;" v-else>{{ globalDataArray.siteTemplateLanguage.system_data_empty_tips }}</div>
      </div>
    </div>

    <!-- 桌面端右侧导航按钮 -->
    <!-- <div class="sectionNavBtn" @click="sectionNavFun" v-if="isClient && showNav && headings.length">
      <div class="arrowLeft"></div>
      <div class="arrowRight" style="display: none;"></div>
      <span :class="getCurrentLanguage() === 'zh_CN' || getCurrentLanguage() === 'zh' ? 'rotate-text-zh' : 'rotate-text'">
        {{ globalDataArray.siteTemplateLanguage.chapter_navigation }}
      </span>
    </div> -->
    <!-- 移动端章节导航按钮（1700px及以下显示） -->
    <div class="mobile-section-nav-btn" @click="sectionNavFun" v-if="isClient && windowWidth <= 1700 && currentArticle && headings.length">
      <div class="nav-arrow" :class="{ 'nav-arrow-open': navOpen }">
        <svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1 1L6 6L1 11" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </div>
      <span class="nav-text" :class="{ 'english': getCurrentLanguage() !== 'zh_CN' && getCurrentLanguage() !== 'zh' }">
        {{ globalDataArray.siteTemplateLanguage.chapter_navigation }}
      </span>
    </div>
    <aside class="section-nav" v-show="isClient && currentArticle && headings.length">
      <div class="nav-wrapper">
        <div class="nav-list">
          <div
            v-for="heading in headings"
            :key="heading.id"
            class="nav-item"
            :class="{ 'nav-item-active': activeHeading === heading.id }"
            @click="handleNavClick(heading)"
          >
            {{ heading.title }}
          </div>
        </div>
      </div>
    </aside>
  </div>
</template>

<script>
import Cookies from 'js-cookie'
import { stringToDateTime } from '@/utils/util'
import { previewStInfo } from '@/api/saiti'
import { getAdList } from '@/api/api'
import { message } from 'ant-design-vue'
import { marked } from 'marked'

// 配置 marked 解析器 - 简化版本，无代码高亮
marked.setOptions({
  breaks: true,
  gfm: true,
  sanitize: false,
  async: false
})

export default {
  name: 'Previewinfo',
  data() {
    return {
      title: this.globalDataArray.siteInfo.title,
      description: this.globalDataArray.siteInfo.description,
      keywords: this.globalDataArray.siteInfo.keywords,
      oauthUrl: 'https://auth.test.atomgit.com',
      banners: [],
      competition: {},
      currentTime: new Date().getTime(), // 当前地区时区时间
      event: 0,
      info: {},

      signway: false,
      signtype: '',

      formsign: false,
      formteen: false,
      formen: false,
      formenteen: false,

      formapply: false,

      formmsg: false,

      curInfoArray: {
        categoryId: '', // 当前赛题分类id
        competitionId: '', // 当前赛题id
        templateId: '', // 报名模板
        currentLanguge: '',
        teamsUsers: ''
      },

      formxieyi: false,

      showNav: false,
      currentArticle: null,
      headings: [],
      navOpen: false,
      activeHeading: null,
      resizeTimeout: null,
      isClient: false,
      isMobile: false,
      windowWidth: 1920, // 新增，记录当前窗口宽度
      isNavigating: false,
      lastClickTime: 0,
      clickDebounceDelay: 200,
      navigationTimer: null
    }
  },
  created() {

  },
  mounted() {
    this.isClient = true
    this.showNav = window.innerWidth > 997
    this.isMobile = window.innerWidth <= 768
    this.windowWidth = window.innerWidth // 新增
    window.addEventListener('resize', this.handleResize)
    window.addEventListener('scroll', this.handleScrollThrottle)
    document.addEventListener('click', this.handleClickOutside)
    this.init()
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
    window.removeEventListener('scroll', this.handleScrollThrottle)
    document.removeEventListener('click', this.handleClickOutside)
    if (this.resizeTimeout) clearTimeout(this.resizeTimeout)
  },
  methods: {
    init() {
      const that = this
      const adParam = 'alias=newsinfo_banner'
      getAdList(adParam).then(res => {
        if (res.success) {
          if (res.result.length > 0) {
            that.banners = res.result[0]
          }
        }
      })
      // that.getNowDate()//获取当前时间
      that.getCompetitionInfo()
    },
    changeEvent(e) {
      const that = this
      that.event = e
      that.info = that.competition.info[that.event]

      // 更新当前文章并重新解析标题
      that.currentArticle = that.info
      that.$nextTick(() => {
        that.parseHeadings()
      })
    },
    // 解析Markdown内容 - 与详情页保持一致
    parseMarkdown(content) {
      try {
        if (!content || typeof content !== 'string') {
          return '<p>内容为空</p>'
        }

        // 先解码HTML实体和Unicode转义序列
        const decodedContent = this.decodeHtmlEntities(content)

        const parsed = marked.parse(decodedContent)
        if (!parsed || parsed.trim() === '') {
          return `<div class="markdown-fallback"><pre>${this.cleanDOMBreakingContent(decodedContent)}</pre></div>`
        }

        // 对解析后的内容进行安全清理，但保留HTML结构
        const cleanedParsed = this.cleanDOMBreakingContent(parsed)

        return cleanedParsed
      } catch (e) {
        console.error('parseMarkdown: 解析失败:', e)
        return `<div class="markdown-error">
          <p class="error">Markdown解析异常</p>
          <details>
            <summary>查看原始内容</summary>
            <pre>${content}</pre>
          </details>
        </div>`
      }
    },
    // 强化的HTML实体和转义序列解码函数 - 与详情页一致
    decodeHtmlEntities(content) {
      if (!content || typeof content !== 'string') {
        return content
      }

      let decoded = content

      try {
        // 直接解码常见的JSON转义序列，包括空白字符
        if (decoded.includes('\\u003C') || decoded.includes('\\u002F') || decoded.includes('\\"') || decoded.includes('\\u0020') || decoded.includes('\\u0009')) {
          // 直接替换常见的JSON编码字符，包括各种空白字符
          const jsonReplacements = {
            '\\u003C': '<',
            '\\u003E': '>',
            '\\u002F': '/',
            '\\u0026': '&',
            '\\u0022': '"',
            '\\u0027': "'",
            '\\u003D': '=',
            '\\u0020': ' ', // 普通空格
            '\\u00A0': '\u00A0', // 不换行空格 (NBSP)
            '\\u000A': '\n', // 换行
            '\\u000D': '\r', // 回车
            '\\u0009': '\t', // 制表符
            '\\u000B': '\v', // 垂直制表符
            '\\u000C': '\f' // 换页符
          }
          Object.keys(jsonReplacements).forEach(encoded => {
            if (decoded.includes(encoded)) {
              decoded = decoded.replace(new RegExp(encoded, 'g'), jsonReplacements[encoded])
            }
          })
        }

        // 安全地解码Unicode转义序列（\uXXXX格式），保留空白字符
        decoded = decoded.replace(/\\u([0-9a-fA-F]{4})/g, (match, code) => {
          const charCode = parseInt(code, 16)
          // 保留有用的空白字符，跳过危险的控制字符
          if (charCode >= 0x0000 && charCode <= 0x001F &&
              charCode !== 0x0009 && // tab
              charCode !== 0x000A && // 换行
              charCode !== 0x000D && // 回车
              charCode !== 0x000B && // 垂直制表符
              charCode !== 0x000C) {
            return '' // 跳过其他危险的控制字符
          }
          if (charCode >= 0x200B && charCode <= 0x200D) {
            return '' // 跳过零宽字符
          }
          return String.fromCharCode(charCode)
        })

        // 解码各种类型的转义序列，包括空白字符的不同表示形式
        decoded = decoded.replace(/\\n/g, '\n') // 换行
        decoded = decoded.replace(/\\t/g, '\t') // 制表符
        decoded = decoded.replace(/\\r/g, '\r') // 回车
        decoded = decoded.replace(/\\v/g, '\v') // 垂直制表符
        decoded = decoded.replace(/\\f/g, '\f') // 换页符
        decoded = decoded.replace(/\\ /g, ' ') // 转义的空格
        decoded = decoded.replace(/\\"/g, '"') // 双引号
        decoded = decoded.replace(/\\'/g, "'") // 单引号
        decoded = decoded.replace(/\\\\/g, '\\') // 反斜杠（放在最后处理）

        // 手动解码常见的HTML实体，包括各种空白字符
        const htmlEntities = {
          '&amp;': '&',
          '&lt;': '<',
          '&gt;': '>',
          '&quot;': '"',
          '&#39;': "'",
          '&#x27;': "'",
          '&#x2F;': '/',
          '&#x60;': '`',
          '&#x3D;': '=',
          // 空白字符的HTML实体
          '&nbsp;': '\u00A0', // 不换行空格
          '&ensp;': '\u2002', // En空格 (en space)
          '&emsp;': '\u2003', // Em空格 (em space)
          '&thinsp;': '\u2009', // 细空格 (thin space)
          '&#32;': ' ', // 普通空格
          '&#160;': '\u00A0', // 不换行空格 (NBSP)
          '&#9;': '\t', // 制表符
          '&#09;': '\t', // 制表符（前导零）
          '&#x09;': '\t', // 制表符（十六进制）
          '&#x0009;': '\t', // 制表符（十六进制完整）
          '&#13;': '\r', // 回车
          '&#10;': '\n', // 换行
          '&#x0A;': '\n', // 换行（十六进制）
          '&#x0D;': '\r' // 回车（十六进制）
        }

        Object.keys(htmlEntities).forEach(entity => {
          if (decoded.includes(entity)) {
            decoded = decoded.replace(new RegExp(entity, 'g'), htmlEntities[entity])
          }
        })
      } catch (error) {
        // 如果解码失败，至少尝试基本的安全Unicode解码，保留空白字符
        decoded = content.replace(/\\u([0-9a-fA-F]{4})/g, (match, code) => {
          const charCode = parseInt(code, 16)
          // 解码安全字符，包括重要的空白字符
          if ((charCode >= 0x0020 && charCode < 0x200B) || // 基本安全字符范围
              charCode === 0x0009 || // tab
              charCode === 0x000A || // 换行
              charCode === 0x000D || // 回车
              charCode === 0x00A0) { // 不换行空格
            return String.fromCharCode(charCode)
          }
          return ''
        })
      }

      return decoded
    },
    // 加强版：清理可能导致DOM错误的字符但保留HTML结构 - 与详情页一致
    cleanDOMBreakingContent(content) {
      if (!content || typeof content !== 'string') {
        return '<p>内容为空</p>'
      }

      try {
        let cleaned = content

        // 1. 移除可能导致appendChild错误的零宽字符和控制字符，但保留有效的空白字符
        cleaned = cleaned.replace(/[\u200B-\u200D\uFEFF]/g, '') // 零宽字符
        // 危险的控制字符，但保留tab(\u0009)、换行(\u000A)、回车(\u000D)
        cleaned = cleaned.replace(/[\u0000-\u0008\u000B\u000C\u000E-\u001F\u007F]/g, '') // 危险的控制字符

        // 2. 清理BOM和替换字符
        cleaned = cleaned.replace(/^\uFEFF/, '') // 移除BOM
        cleaned = cleaned.replace(/\uFFFD/g, '') // 移除替换字符

        // 3. 新增：修复可能导致appendChild错误的特殊HTML结构
        // 移除可能导致DOM解析问题的注释节点
        cleaned = cleaned.replace(/<!--[\s\S]*?-->/g, '')

        // 修复嵌套不当的标签（可能导致appendChild错误）
        cleaned = this.fixNestedTags(cleaned)

        // 修复可能的孤立尖括号（但保留正确的HTML标签）
        cleaned = this.fixBrokenAngularBrackets(cleaned)

        // 4. 清理可能导致DOM问题的空属性和畸形属性
        cleaned = cleaned.replace(/\s+(\w+)=""\s*/g, ' ') // 移除空属性
        cleaned = cleaned.replace(/\s+(\w+)="\s*"\s*/g, ' ') // 移除只有空白的属性
        // 修复畸形的属性（没有引号或引号不匹配）
        cleaned = this.fixMalformedAttributes(cleaned)

        // 5. 新增：CDN环境下的特殊处理
        if (this.isCDNEnvironment()) {
          cleaned = this.applyCDNSpecificFixes(cleaned)
        }

        // 6. 新增：响应式环境下的DOM结构统一化
        cleaned = this.normalizeResponsiveContent(cleaned)

        // 7. 最终安全检查
        if (!cleaned.trim()) {
          return '<p>内容为空</p>'
        }

        // 验证清理后的内容是否仍然有效
        if (!this.basicContentValidation(cleaned)) {
          console.warn('内容清理后仍不安全，使用纯文本版本')
          return `<p>${this.escapeHtml(content.replace(/<[^>]*>/g, '').trim().substring(0, 200))}...</p>`
        }

        return cleaned
      } catch (error) {
        console.error('cleanDOMBreakingContent error:', error)
        return `<p style="color: #999;">内容处理出错: ${this.escapeHtml(error.message)}</p>`
      }
    },
    // 新增：修复嵌套不当的HTML标签 - 与详情页一致
    fixNestedTags(content) {
      try {
        // 修复常见的嵌套问题，如p标签内嵌套div等块级元素
        let fixed = content

        // 移除p标签内的块级元素嵌套
        fixed = fixed.replace(/<p([^>]*)>([\s\S]*?)<div([^>]*)>([\s\S]*?)<\/div>([\s\S]*?)<\/p>/gi,
          '<p$1>$2</p><div$3>$4</div><p>$5</p>')

        // 修复self-closing标签的问题
        fixed = fixed.replace(/<(br|hr|img|input|meta|link)\s+([^>]*?)\s*>/gi, '<$1 $2 />')

        // 修复未闭合的标签（基础修复）
        const voidElements = ['area', 'base', 'br', 'col', 'embed', 'hr', 'img', 'input', 'link', 'meta', 'source', 'track', 'wbr']
        voidElements.forEach(tag => {
          const regex = new RegExp(`<${tag}([^>]*?)(?<!/)>`, 'gi')
          fixed = fixed.replace(regex, `<${tag}$1 />`)
        })

        return fixed
      } catch (error) {
        console.warn('修复嵌套标签失败:', error)
        return content
      }
    },
    // 新增：修复破损的尖括号 - 与详情页一致
    fixBrokenAngularBrackets(content) {
      try {
        let fixed = content

        // 更安全的方式处理孤立的尖括号，避免破坏正确的HTML标签
        // 使用负向后瞻和前瞻来识别真正孤立的尖括号
        fixed = fixed.replace(/(?<!<[^>]*)<(?![a-zA-Z\/!?\s])/g, '&lt;')
        fixed = fixed.replace(/(?<![a-zA-Z0-9\s"'=\/])>(?!\s*[<\w])/g, '&gt;')

        // 修复属性中的问题尖括号
        fixed = fixed.replace(/(\w+="[^"]*)<([^">]*")/g, '$1&lt;$2')
        fixed = fixed.replace(/(\w+="[^"]*)>([^">]*")/g, '$1&gt;$2')

        return fixed
      } catch (error) {
        console.warn('修复尖括号失败:', error)
        return content
      }
    },
    // 新增：修复畸形的HTML属性 - 与详情页一致
    fixMalformedAttributes(content) {
      try {
        let fixed = content

        // 修复没有引号的属性值（但只处理安全的情况）
        fixed = fixed.replace(/(\w+)=([a-zA-Z0-9\-_]+)(?=\s|>)/g, '$1="$2"')

        // 修复单引号属性
        fixed = fixed.replace(/(\w+)='([^']*)'/g, '$1="$2"')

        // 移除无效的属性（如属性名包含特殊字符）
        fixed = fixed.replace(/[^\w\-]+="[^"]*"/g, '')

        return fixed
      } catch (error) {
        console.warn('修复属性失败:', error)
        return content
      }
    },
    // 新增：CDN环境下的特殊修复 - 与详情页一致
    applyCDNSpecificFixes(content) {
      try {
        let fixed = content

        // CDN可能导致的编码问题修复
        // 修复双重编码问题
        fixed = fixed.replace(/&amp;amp;/g, '&amp;')
        fixed = fixed.replace(/&lt;lt;/g, '&lt;')
        fixed = fixed.replace(/&gt;gt;/g, '&gt;')

        // 修复CDN可能引入的额外空白字符
        fixed = fixed.replace(/\u00A0+/g, ' ') // 替换连续的非断空格
        fixed = fixed.replace(/[\u2000-\u200A\u202F\u205F]/g, ' ') // 替换各种空格字符

        // 修复CDN缓存可能导致的版本混合问题
        // 移除可能的版本标识注释
        fixed = fixed.replace(/<!--\s*version[^>]*-->/gi, '')
        fixed = fixed.replace(/<!--\s*cdn[^>]*-->/gi, '')

        return fixed
      } catch (error) {
        console.warn('CDN特殊修复失败:', error)
        return content
      }
    },
    // 新增：响应式内容的DOM结构统一化 - 与详情页一致
    normalizeResponsiveContent(content) {
      try {
        let normalized = content

        // 移除可能导致响应式问题的内联样式（保留基础样式）
        // 只移除可能导致布局冲突的样式
        const problematicStyles = [
          /position\s*:\s*fixed/gi,
          /position\s*:\s*absolute/gi,
          /z-index\s*:\s*\d+/gi,
          /transform\s*:[^;]*/gi
        ]

        problematicStyles.forEach(pattern => {
          normalized = normalized.replace(new RegExp(`style="([^"]*?)${pattern.source}[^"]*"`, 'gi'),
            (match, beforeStyle) => {
              const cleanStyle = beforeStyle.replace(pattern, '').trim()
              return cleanStyle ? `style="${cleanStyle}"` : ''
            })
        })

        // 统一化可能导致响应式问题的类名（如果存在冲突的话）
        // 这里只做基础清理，避免过度处理
        normalized = normalized.replace(/class="[^"]*mobile[^"]*desktop[^"]*"/gi, 'class="responsive-content"')

        return normalized
      } catch (error) {
        console.warn('响应式内容标准化失败:', error)
        return content
      }
    },
    // 新增：基础内容验证（用于服务端和降级场景） - 与详情页一致
    basicContentValidation(content) {
      if (!content || typeof content !== 'string') {
        return false
      }

      // 检查内容长度，过长的内容可能有问题
      if (content.length > 1000000) { // 1MB
        console.warn('内容过长，可能存在问题')
        return false
      }

      // 检查是否包含明显的问题字符或模式
      const dangerousPatterns = [
        /<script[^>]*>[\s\S]*?<\/script>/gi, // 脚本标签
        /javascript:/gi, // JavaScript协议
        /on\w+\s*=/gi, // 事件处理器
        /<iframe[^>]*>[\s\S]*?<\/iframe>/gi, // iframe标签
        /<object[^>]*>[\s\S]*?<\/object>/gi, // object标签
        /<embed[^>]*>/gi // embed标签
      ]

      for (const pattern of dangerousPatterns) {
        if (pattern.test(content)) {
          console.warn('发现潜在危险内容模式')
          return false
        }
      }

      // 检查HTML标签是否成对出现（基础检查）
      const openTags = (content.match(/<[^/][^>]*>/g) || []).length
      const closeTags = (content.match(/<\/[^>]*>/g) || []).length
      const selfClosingTags = (content.match(/<[^>]*\/>/g) || []).length

      // 简单的标签平衡检查
      if (Math.abs(openTags - closeTags - selfClosingTags) > 5) {
        console.warn('HTML标签可能不平衡')
        return false
      }

      return true
    },
    // 新增：检查是否在CDN环境 - 与详情页一致
    isCDNEnvironment() {
      if (this.$isServer) return false

      try {
        const hostname = window.location.hostname
        const userAgent = navigator.userAgent || ''

        // 检查是否包含CDN相关域名特征
        const cdnPatterns = [
          /\.cdn\./i,
          /\.cloudflare\./i,
          /\.cloudfront\./i,
          /\.fastly\./i,
          /\.jsdelivr\./i,
          /\.unpkg\./i,
          /cache/i,
          /edge/i
        ]

        const hasCDNDomain = cdnPatterns.some(pattern => pattern.test(hostname))

        // 检查请求头或其他CDN标识
        const hasCDNHeaders = document.querySelector('meta[name="cdn"]') !== null

        return hasCDNDomain || hasCDNHeaders
      } catch (error) {
        return false
      }
    },
    // 新增：HTML转义函数 - 与详情页一致
    escapeHtml(text) {
      if (!text || typeof text !== 'string') return ''

      try {
        if (this.$isServer) {
          // 服务端环境使用简单替换
          return text
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#39;')
        } else {
          // 客户端环境使用DOM方法
          const div = document.createElement('div')
          div.textContent = text
          return div.innerHTML
        }
      } catch (error) {
        // 降级到简单替换
        return text
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;')
          .replace(/'/g, '&#39;')
      }
    },
    getCompetitionInfo() {
      const that = this
      const param = 'id=' + this.$route.query.id
      previewStInfo(param).then(res => {
        if (res.success) {
          that.competition = res.result

          if (that.competition.title != '' && that.competition.title != null) {
            that.title = that.competition.title + '-' + that.globalDataArray.siteInfo.title
          }
          if (that.competition.keywords != '' && that.competition.keywords != null) {
            that.keywords = that.competition.keywords
          }
          if (that.competition.description != '' && that.competition.description != null) {
            that.description = that.competition.description
          }

          that.info = that.competition.info[that.event]

          // 更新当前文章并解析标题
          that.currentArticle = that.info
          that.$nextTick(() => {
            that.parseHeadings()
          })

          // console.log(that.info,res.result.info,'info')
          if (that.competition.mark) {
            // 同时处理中英文逗号，过滤空值
            that.competition.mark = that.competition.mark.split(/[,，]/).filter(item => item.trim())
          }

          if (that.competition.organizersLogo) {
            // 同时处理中英文逗号，过滤空值
            that.competition.organizersLogo = that.competition.organizersLogo.split(/[,，]/).filter(item => item.trim())
          }

          if (that.competition.organizers) {
            // 同时处理中英文逗号，过滤空值
            that.competition.organizers = that.competition.organizers.split(/[,，]/).filter(item => item.trim())
          }

          // 将utc时间转为当地时间并作比较
          const endUtcTime = that.competition.endUtcTime
          const localEndtimeStr = new Date(endUtcTime).getTime()
          that.competition['localEndtime'] = stringToDateTime(localEndtimeStr)

          that.competition['localEndtimeStr'] = localEndtimeStr

          const startUtcTime = that.competition.startUtcTime
          const localStarttimeStr = new Date(startUtcTime).getTime()
          that.competition['localStarttime'] = stringToDateTime(localStarttimeStr)

          // 筛选三种状态  过去  距离现在最近  未来
          const progress = that.competition.progress
          if (progress && Array.isArray(progress)) {
            const curProgress = []
            progress.forEach((item, index) => {
              const pStartUtcDate = item.startUtcDate
              const pStartLocalStr = new Date(pStartUtcDate).getTime()
              item['pStartLocalStr'] = pStartLocalStr

              if (that.currentTime > pStartLocalStr) {
                curProgress.push(Number(pStartLocalStr))
              } else {
                item['progressStatus'] = '2'
              }
            })

            // 打散获取最大值
            if (curProgress.length > 0) {
              const mathMax = Math.max(...curProgress)

              progress.forEach((item, index) => {
                if (item.pStartLocalStr == mathMax) {
                  item['progressStatus'] = '1'
                } else if (item.progressStatus != 2) {
                  item['progressStatus'] = '0'
                }
              })
            }
          }
        } else {
          if (res.code == 404) {
            message.error(res.message)
            this.$router.push({ path: '/competition' })
          }
        }
      })
    },

    handleLogin() {
      const redirectUrl = encodeURIComponent(location.href)
      Cookies.set('atom_redirect', redirectUrl, { domain: '.atomgit.com', expires: 180, path: '/', secure: true })
      location.href = this.oauthUrl
    },

    sectionNavFun() {
      this.$nextTick(() => {
        const nav = document.querySelector('.section-nav')
        if (!nav) return
        const screenWidth = this.windowWidth
        if (screenWidth <= 1700) {
          const isOpen = nav.classList.contains('show')
          nav.classList.toggle('show')
          this.navOpen = !isOpen
        }
        // 桌面端不做任何显示/隐藏操作
      })
    },

    // 执行实际的导航操作（参考 info.vue）
    performNavigation(heading) {
      const element = document.getElementById(heading.id)
      if (!element) return

      // 清除所有之前的定时器和状态
      if (this.navigationTimer) {
        clearTimeout(this.navigationTimer)
        this.navigationTimer = null
      }

      // 立即更新激活状态
      this.activeHeading = heading.id
      this.isNavigating = true
      this.updateNavActiveState(heading.id)

      // 自动根据屏幕宽度调整 offset，大屏无偏移，小屏保留 100
      const isLargeScreen = this.windowWidth > 1700
      const fixedOffset = isLargeScreen ? 0 : 100
      const elementRect = element.getBoundingClientRect()
      const currentScrollTop = window.scrollY || document.documentElement.scrollTop
      const elementTop = elementRect.top + currentScrollTop
      const targetScrollTop = elementTop - fixedOffset
      window.scrollTo({ top: Math.max(0, targetScrollTop), behavior: 'smooth' })

      // 设置较短的恢复时间，减少状态锁定时间
      this.navigationTimer = setTimeout(() => {
        this.isNavigating = false
        this.navigationTimer = null
        this.updateNavActiveState(heading.id)
      }, 800)
    },

    // 处理导航点击事件（参考 info.vue，带防抖）
    handleNavClick(heading) {
      if (this.$isServer) return
      const currentTime = Date.now()
      if (!this.lastClickTime) this.lastClickTime = 0
      if (!this.clickDebounceDelay) this.clickDebounceDelay = 200
      if (currentTime - this.lastClickTime < this.clickDebounceDelay) {
        if (this.navigationTimer) {
          clearTimeout(this.navigationTimer)
        }
        this.navigationTimer = setTimeout(() => {
          this.performNavigation(heading)
        }, this.clickDebounceDelay)
        return
      }
      this.lastClickTime = currentTime
      this.performNavigation(heading)
    },

    getCurrentArticleContentObj() {
      if (!this.$el) return null
      return this.$el.querySelector('.content_st')
    },

    parseHeadings() {
      this.headings = []
      const content = this.getCurrentArticleContentObj()
      if (!content) return
      const headingElements = content.querySelectorAll('h1, h2, h3, h4, h5, h6')
      headingElements.forEach((el, index) => {
        const headingId = `heading-0-${index}`
        el.id = headingId
        el.style.scrollMarginTop = '0px'
        this.headings.push({
          id: headingId,
          title: el.textContent.trim(),
          level: parseInt(el.tagName.charAt(1))
        })
      })
      this.$nextTick(() => {
        if (this.headings.length > 0) {
          this.activeHeading = this.headings[0].id
          this.updateNavActiveState(this.headings[0].id)
          this.handleScroll()
        }
      })
    },

    handleResize() {
      if (this.$isServer || !this.isClient) return
      this.windowWidth = window.innerWidth // 新增
      try {
        if (this.resizeTimeout) {
          clearTimeout(this.resizeTimeout)
        }
        this.resizeTimeout = setTimeout(() => {
          const currentWidth = window.innerWidth
          this.windowWidth = currentWidth // 新增
          const newIsMobile = currentWidth <= 768
          const newShowNav = currentWidth > 997
          if (this.isMobile !== newIsMobile) {
            this.isMobile = newIsMobile
          }
          if (this.showNav !== newShowNav) {
            const previousShowNav = this.showNav
            this.showNav = newShowNav
            if (!previousShowNav && newShowNav && this.currentArticle) {
              this.$nextTick(() => {
                this.parseHeadings()
              })
            }
          }
          this.$nextTick(() => {
            try {
              const nav = document.querySelector('.section-nav')
              if (nav) {
                if (currentWidth <= 1700) {
                  nav.classList.remove('show')
                  if (nav.style.display === 'block') {
                    nav.style.display = ''
                  }
                  this.navOpen = false
                } else {
                  nav.classList.remove('show')
                  this.navOpen = false
                }
              }
            } catch (navError) {
              console.warn('导航状态重置失败:', navError)
            }
          })
        }, 100)
      } catch (error) {
        console.error('窗口大小变化处理失败:', error)
      }
    },

    handleScrollThrottle() {
      cancelAnimationFrame(this.scrollFrame)
      this.scrollFrame = requestAnimationFrame(this.handleScroll)
    },

    handleScroll() {
      if (this.isNavigating) return
      if (!this.headings.length) return
      const scrollTop = window.scrollY || document.documentElement.scrollTop
      const viewportHeight = window.innerHeight
      const viewportTop = scrollTop
      const viewportBottom = scrollTop + viewportHeight
      const pageTopOffset = this.getPageTopOffset()
      let maxVisibility = 0
      let mostVisibleHeading = ''
      for (let i = 0; i < this.headings.length; i++) {
        const currentElement = document.getElementById(this.headings[i].id)
        if (!currentElement) continue
        const currentRect = currentElement.getBoundingClientRect()
        const titleBottom = currentRect.bottom + scrollTop
        let sectionStart = titleBottom
        let sectionEnd
        if (i < this.headings.length - 1) {
          const nextElement = document.getElementById(this.headings[i + 1].id)
          if (nextElement) {
            const nextRect = nextElement.getBoundingClientRect()
            sectionEnd = nextRect.top + scrollTop
          } else {
            const contentElement = this.getCurrentArticleContentObj()
            sectionEnd = contentElement ? (contentElement.getBoundingClientRect().bottom + scrollTop) : (scrollTop + viewportHeight * 2)
          }
        } else {
          const contentElement = this.getCurrentArticleContentObj()
          if (contentElement) {
            const contentRect = contentElement.getBoundingClientRect()
            sectionEnd = contentRect.bottom + scrollTop
          } else {
            sectionEnd = document.documentElement.scrollHeight
          }
        }
        if (sectionEnd - sectionStart < 50) {
          const titleTop = currentRect.top + scrollTop
          sectionStart = titleTop - 100
          sectionEnd = titleTop + 300
        }
        const visibility = this.calculateSectionVisibility(sectionStart, sectionEnd, viewportTop, viewportBottom)
        const titleInViewport = currentRect.top >= 0 && currentRect.bottom <= viewportHeight
        const titleNearCenter = Math.abs(currentRect.top + currentRect.height / 2 - viewportHeight / 2) < viewportHeight * 0.3
        let finalVisibility = visibility
        if (titleInViewport && titleNearCenter) {
          finalVisibility = Math.max(visibility, 0.6)
        }
        if (finalVisibility > maxVisibility) {
          maxVisibility = finalVisibility
          mostVisibleHeading = this.headings[i].id
        }
      }
      if (!mostVisibleHeading || maxVisibility < 0.1) {
        for (let i = this.headings.length - 1; i >= 0; i--) {
          const element = document.getElementById(this.headings[i].id)
          if (element) {
            const elementRect = element.getBoundingClientRect()
            const elementTop = elementRect.top + scrollTop
            if (elementTop <= scrollTop + pageTopOffset + 150) {
              mostVisibleHeading = this.headings[i].id
              break
            }
          }
        }
        if (!mostVisibleHeading && scrollTop < pageTopOffset + 200 && this.headings.length > 0) {
          mostVisibleHeading = this.headings[0].id
        }
        if (!mostVisibleHeading && (viewportTop + viewportHeight) >= (document.documentElement.scrollHeight - 100)) {
          mostVisibleHeading = this.headings[this.headings.length - 1].id
        }
      }
      if (mostVisibleHeading && mostVisibleHeading !== this.activeHeading) {
        this.activeHeading = mostVisibleHeading
      }
      // 自动滚动导航条高亮项到可视区
      this.$nextTick(() => {
        const nav = this.$el && this.$el.querySelector('.section-nav.show')
        const activeNavItem = nav && nav.querySelector('.nav-item-active')
        if (activeNavItem && nav) {
          activeNavItem.scrollIntoView({ block: 'nearest', behavior: 'smooth' })
        }
      })
    },

    getPageTopOffset() {
      let topOffset = 0
      const banner = document.querySelector('.banner')
      const question = document.querySelector('.question')
      if (banner) topOffset += banner.offsetHeight
      if (question) topOffset += question.offsetHeight
      const contentArea = document.querySelector('.contenta')
      if (contentArea) {
        const contentRect = contentArea.getBoundingClientRect()
        const currentScrollTop = window.scrollY || document.documentElement.scrollTop
        const contentTop = contentRect.top + currentScrollTop
        topOffset = Math.max(topOffset, contentTop)
      }
      return topOffset
    },

    calculateSectionVisibility(sectionStart, sectionEnd, viewportTop, viewportBottom) {
      const visibleStart = Math.max(sectionStart, viewportTop)
      const visibleEnd = Math.min(sectionEnd, viewportBottom)
      if (visibleStart >= visibleEnd) return 0
      const visibleHeight = visibleEnd - visibleStart
      const sectionHeight = sectionEnd - sectionStart
      const viewportHeight = viewportBottom - viewportTop
      const viewportRatio = visibleHeight / viewportHeight
      const sectionRatio = visibleHeight / sectionHeight
      const weightedRatio = (viewportRatio * 0.7) + (sectionRatio * 0.3)
      return Math.min(weightedRatio, 1)
    },

    updateNavActiveState(headingId) {
      const newHash = `#${headingId}`
      if (window.location.hash !== newHash) {
        window.history.replaceState(null, null, newHash)
      }
      this.activeHeading = headingId
    },

    handleClickOutside(event) {
      if (window.innerWidth > 997) return
      const nav = document.querySelector('.section-nav')
      const navBtn = document.querySelector('.mobile-section-nav-btn')
      if (!nav || !navBtn) return
      const isClickInsideNav = nav.contains(event.target)
      const isClickInsideBtn = navBtn.contains(event.target)
      if (!isClickInsideNav && !isClickInsideBtn && nav.classList.contains('show')) {
        nav.classList.remove('show')
        this.navOpen = false
      }
    },

    getCurrentLanguage() {
      // 优先使用 Cookie 中的语言设置
      const cookieLang = Cookies.get('DEFAULT_LANG')
      if (cookieLang) {
        return cookieLang
      }
      // 其次使用全局语言设置
      if (this.globalDataArray && this.globalDataArray.siteInfo && this.globalDataArray.siteInfo.language) {
        return this.globalDataArray.siteInfo.language
      }
      // 默认返回中文
      return 'zh_CN'
    }
  },

  metaInfo() {
    return {
      title: this.title,
      meta: [
        { vmid: 'description', name: 'description', content: this.description },
        { vmid: 'keywords', name: 'keywords', content: this.keywords }
      ]
    }
  },

  watch: {
    info: {
      handler(newVal) {
        this.currentArticle = newVal
        this.$nextTick(() => {
          this.parseHeadings()
        })
      },
      immediate: true
    }
  }
}
</script>
<style>
@import '@/assets/css/problem_des.css';
@import '@/assets/css/markdown_table.css';

/* 通用链接样式 - 与详情页完全一致，支持颜色继承 */
.pageMain .contenta .txt.ck-content a,
html body .ck-content a,
.ck-content a {
  color: #0969da; /* 默认蓝色 */
  text-decoration: none !important;
  border-bottom: 1px solid transparent !important;
  transition: all 0.2s ease !important;
}

/* 有颜色父级容器时，链接继承颜色 */
.pageMain .contenta .txt.ck-content [style*="color"] a,
html body .ck-content [style*="color"] a,
.ck-content [style*="color"] a {
  color: inherit !important; /* 继承父元素的颜色 */
}

.pageMain .contenta .txt.ck-content a:hover,
html body .ck-content a:hover,
.ck-content a:hover {
  text-decoration: none !important;
  border-bottom: 1px solid currentColor !important;
}

/* 表格内链接样式 - 继承通用样式 */
.pageMain .contenta .txt.ck-content table a,
html body .ck-content table a,
.ck-content table a,
table a {
  color: #0969da; /* 默认蓝色 */
  text-decoration: none !important;
  border-bottom: 1px solid transparent !important;
  transition: all 0.2s ease !important;
}

/* 表格内有颜色父级容器时，链接继承颜色 */
.pageMain .contenta .txt.ck-content table [style*="color"] a,
html body .ck-content table [style*="color"] a,
.ck-content table [style*="color"] a,
table [style*="color"] a {
  color: inherit !important; /* 继承父元素的颜色 */
}

.pageMain .contenta .txt.ck-content table a:hover,
html body .ck-content table a:hover,
.ck-content table a:hover,
table a:hover {
  border-bottom: 1px solid currentColor !important;
  text-decoration: none !important;
}

.mobile-section-nav-btn {
  position: fixed;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
  background: #fff;
  border: 1px solid #e8e8e8;
  border-radius: 6px;
  padding: 8px;
  cursor: pointer;
  z-index: 9998;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  width: 40px;
  min-height: 120px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
}
.mobile-section-nav-btn .nav-text {
  text-orientation: upright;
  font-size: 12px;
  color: #333;
  line-height: 1.2;
  letter-spacing: 1px;
  padding: 0 8px;
}
.mobile-section-nav-btn .nav-text.english {
  transform: rotate(90deg);
  transform-origin: center;
  font-size: 12px;
  color: #333;
  line-height: 1.2;
  white-space: nowrap;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  overflow: visible;
  padding: 0;
  margin: 0;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  backface-visibility: hidden;
  will-change: transform;
  transform-style: preserve-3d;
  perspective: 1000px;
}

.section-nav {
  position: fixed;
  top: 50%;
  right: 70px;
  transform: translateY(-50%);
  background: #fff;
  border: 1px solid #e8e8e8;
  border-radius: 6px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  z-index: 9997;
  width: 200px;
  max-height: 400px;
  overflow-y: auto;
  display: none;
  opacity: 0;
  transition: opacity 0.3s;
}

.section-nav.show {
  opacity: 1;
  pointer-events: auto;
}
.nav-wrapper {
  position: relative;
}

.nav-list {
  padding: 0;
  margin: 0;
}

.nav-item {
  padding: 3px 0;
  line-height: 1.5;
  color: #666;
  font-size: 12px;
  cursor: pointer;
  transition: color 0.2s ease;
  border-left: 2px solid transparent;
  padding-left: 8px;
  margin-left: -8px;
}

.nav-item:hover {
  color: #1890ff;
}

.nav-item-active {
  color: #1890ff !important;
  border-left-color: #1890ff;
  font-size: 12px;
}

/* 1700px及以下，section-nav 默认隐藏，按钮控制显隐 */
@media (max-width: 1700px) {
  .mobile-section-nav-btn {
    position: fixed;
    top: 50%;
    right: 10px;
    transform: translateY(-50%);
    background: #fff;
    border: 1px solid #e8e8e8;
    border-radius: 6px;
    padding: 8px; /* 基础padding */
    cursor: pointer;
    z-index: 9998;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    transition: all 0.3s ease;
    width: 40px;
    height: auto;
    min-height: 120px; /* 增加高度以完整显示"Section Navigation" */
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    justify-items: center;
    gap: 6px;

    /* 优化容器渲染，防止点击时抖动 */
    -webkit-tap-highlight-color: transparent;
    backface-visibility: hidden;
    transform-style: preserve-3d;
  }

  /* 英文状态下的容器额外padding */
  .mobile-section-nav-btn .nav-text.english {
    margin: 8px 0; /* 通过margin补偿旋转后的视觉边距 */
  }

  .mobile-section-nav-btn:hover {
    background: #f5f5f5;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    /* 确保hover状态不会导致文字抖动 */
    transform: translateY(-50%);
    backface-visibility: hidden;
  }

  .mobile-section-nav-btn:active {
    /* 优化点击状态，防止抖动 */
    transform: translateY(-50%) scale(0.98);
    transition: transform 0.1s ease;
    backface-visibility: hidden;
  }

  .nav-arrow {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #666;
    transition: transform 0.3s ease;
  }

  .nav-arrow-open {
    transform: rotate(180deg);
  }

  /* 英文状态下的旋转样式 */
  .nav-text.english {
    transform: rotate(90deg);
    transform-origin: center;
    font-size: 12px;
    color: #333;
    line-height: 1.2;
    letter-spacing: 0.5px;
    white-space: nowrap;
    height: 100px; /* 足够高度完整显示"Section Navigation" */
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px; /* 设置固定宽度，移除max-width限制 */
    overflow: visible; /* 允许文字完整显示 */
    padding: 0; /* 移除文字自身padding，通过外部容器控制 */
    margin: 0; /* 确保没有额外margin */

    /* 优化旋转文字渲染，防止模糊抖动 */
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    backface-visibility: hidden;
    will-change: transform;
    transform-style: preserve-3d;
    perspective: 1000px;
  }

  .section-nav {
    position: fixed;
    top: 50%;
    right: 70px;
    transform: translateY(-50%);
    background: #fff;
    border: 1px solid #e8e8e8;
    border-radius: 6px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    z-index: 9997;
    width: 200px;
    max-height: 400px;
    overflow-y: auto;
    display: none;
    opacity: 0;
    transition: opacity 0.3s ease;
    padding: 14px;
  }

  .section-nav.show {
    display: block;
    opacity: 1;
  }

  .nav-item {
    padding: 10px 15px;
    font-size: 14px;
    border-bottom: 1px solid #f5f5f5;
    transition: background-color 0.2s ease;
  }

  .nav-item:last-child {
    border-bottom: none;
  }

  .nav-item:hover {
    background: #f5f5f5;
  }

  .nav-item-active {
    background: #e6f7ff;
    color: #1890ff;
    border-left: 3px solid #1890ff;
    font-weight: 500;
  }
}
/* 1701px及以上，section-nav 始终显示，按钮隐藏 */
@media (min-width: 1701px) {
  .section-nav {
    position: fixed;
    top: 50%;
    right: 70px;
    transform: translateY(-50%);
    background: #fff;
    border: 1px solid #e8e8e8;
    border-radius: 6px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    z-index: 9997;
    width: 200px;
    max-height: 400px;
    overflow-y: auto;
    display: block;
    opacity: 1;
    transition: opacity 0.3s ease;
  }
  .mobile-section-nav-btn {
    display: none !important;
  }
}
</style>
